export const errorMsg = (data, err) => {
  return {
    _req: { ...data },
    resp: {
      isError: true,
      message: "some error occured",
      ...err
    }
  };
};

export const msgData = (reqData, respData = {}) => {
  return {
    _req: { ...reqData },
    resp: { ...respData }
  };
};

export const isAndroid = () => {
  return navigator.userAgent.toLowerCase().indexOf("android") > -1;
};

export const isIOS = () => {
  return ["iPad", "iPhone", "iPod"].includes(navigator.platform);
};

export const isMobile = () => {
  return isAndroid() || isIOS();
};
